"use client";
import { useState } from "react";

export function AIAssistant() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-gold rounded-full flex items-center justify-center shadow-lg shadow-gold/20 hover:scale-110 transition-transform"
        aria-label="AI Assistant"
      >
        <svg className="w-6 h-6 text-bg" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 3.104v5.714a2.25 2.25 0 01-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 014.5 0m0 0v5.714a2.25 2.25 0 00.659 1.591L19 14.5M14.25 3.104c.251.023.501.05.75.082M19 14.5l-1.341 4.023A2.25 2.25 0 0115.5 20.25H8.5a2.25 2.25 0 01-2.159-1.727L5 14.5m14 0H5" />
        </svg>
      </button>
      {open && (
        <div className="fixed bottom-24 right-6 z-50 w-80 bg-panel border border-white/10 rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-gold/10 border-b border-white/5 px-4 py-3 flex items-center justify-between">
            <span className="text-sm font-semibold text-gold">HoodCoins AI</span>
            <button onClick={() => setOpen(false)} className="text-silver hover:text-white text-lg">&times;</button>
          </div>
          <div className="p-4 h-64 overflow-y-auto space-y-3">
            <div className="bg-panel-light rounded-lg p-3 text-sm text-silver">
              👋 Welcome to HoodCoins! I can help you with:
            </div>
            <ul className="space-y-2 text-sm">
              {["Find the right course", "Choose a trading system", "Deployment guidance", "Strategy recommendations"].map((item) => (
                <li key={item}>
                  <button className="w-full text-left px-3 py-2 rounded-lg bg-panel-light hover:bg-white/5 text-silver hover:text-white transition">
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div className="border-t border-white/5 p-3">
            <input
              type="text"
              placeholder="Ask anything..."
              className="w-full bg-bg border border-white/10 rounded-lg px-3 py-2 text-sm text-white placeholder:text-silver/50 focus:outline-none focus:border-gold/50"
            />
          </div>
        </div>
      )}
    </>
  );
}
